import React from 'react'
import ReactDOM from 'react-dom'
import TagManager from 'react-gtm-module'
import App from './App'

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID as string
}
TagManager.initialize(tagManagerArgs)

declare global {
    interface Window {
        dataLayer: any
    }
}

ReactDOM.render(
    <React.StrictMode>
            <App/>
    </React.StrictMode>,
    document.getElementById('root')
);
